import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import CadastroLotes from './CadastroLotes';
import SelecaoAmostrasLote from './SelecaoAmostrasLote';
import queryString from 'query-string';
import DadosLotesManager from '../DadosLotesManager';
import { makeStyles, CircularProgress } from "@material-ui/core";
import store from '../../../store';
import { mensagemAlertaActions } from '../../mensagemAlerta/redux';
import { formatarCodigoLote } from '../../../shared/utils/Formatacao';
import { TIPO_LOTE_KPA_CODIGO } from '../../../shared/utils/Constantes';
const DadosLote = () => {
    const [carregando, setCarregando] = useState(true);
    const [editando, setEditando] = useState(false);
    const [editandoCriacao, setEditandoCriacao] = useState(false);
    const [selecionarAmostrasLote, setSelecionarAmostrasLote] = useState(false);
    const [dadosLote, setDadosLote] = useState({});
    const [ehLoteKPA, setEhLoteKPA] = useState(false)

    const classes = useStyles();
    const history = useHistory();
    const { search } = useLocation();
    const { idLote } = queryString.parse(search);

    useEffect(() => {
        const obterDadosLote = async (id) => {
            const response = await DadosLotesManager.obterDadosLote(id);

            if (response) {
                setDadosLote(response);
                setSelecionarAmostrasLote(response.quantidadeAmostras > 0);
            }
            else {
                history.goBack();
            }
        }

        if (idLote) {
            setCarregando(true);
            obterDadosLote(idLote);
        }
    }, [idLote, history]);

    useEffect(() => {
        if (dadosLote.id) {
            setCarregando(false);

            if (search) {
                setEditando(true);
            }
        }

        if (!search) {
            setCarregando(false);
        }
    }, [dadosLote, search]);
    
    useEffect(() => {
        if(dadosLote?.tipoLote?.codigo == TIPO_LOTE_KPA_CODIGO) 
            setEhLoteKPA(true)
    }, [dadosLote])

    const handleEndInsertion = (dados) => {
        setDadosLote(dados);
        setSelecionarAmostrasLote(true);

        if (dados.etiquetaGeradaOnboarding && !editando) {
            const mensagem = `O número da etiqueta do lote ${formatarCodigoLote(dados.codigo)}` +
                " foi gerado com sucesso.";
            store.dispatch(mensagemAlertaActions.exibirNotificacaoSucesso(mensagem));
        }
    }

    const handleEditarDados = () => {
        setSelecionarAmostrasLote(false);
        setEditando(true);
        setEditandoCriacao(true);
    }

    return (
        <>
            {carregando
                ? <div>
                    <CircularProgress size={24} className={classes.circularProgress} />
                </div>
                : selecionarAmostrasLote
                    ? <SelecaoAmostrasLote
                        dadosLote={dadosLote}
                        editando={editando}
                        handleEditarDados={handleEditarDados}
                        ehLoteKPA={ehLoteKPA}
                    />
                    : <CadastroLotes
                        dadosLote={dadosLote}
                        editando={editando}
                        editandoCriacao={editandoCriacao}
                        handleEndInsertion={handleEndInsertion}
                    />
            }
        </>
    );
}

const useStyles = makeStyles((theme) => ({
    circularProgress: {
        position: "absolute",
        top: "50%",
        left: "50%",
    }
}));

export default DadosLote;